export default {
    "navsearch": {
        "parish_interventions": {
            "title": "Obra",
            "labelTemplate": "Obra nº ${code}",
            "placeholder": "Obra..."
        }
    },
    "parish_interventions": {
        "view_title": "Visualizar Obra",
        "edit_title": 'Editar Obra',
        "notify_title": "Notificar",
        "model": {
            "abbr_code": "Cod.",
            "abbr_parish": "Freguesia",
            "abbr_parish_old": "Freg. Antiga",
            "code": "Código",
            "status": "Estado",
            "type": "Tipo",
            "subtype": "Subtipo",
            "contract_type": "Tipo Contrato",
            "submission_at": "Data Submissão",
            "execution_at": "Data Execução",
            "parish": "Freguesia",
            "parish_old": "Freguesia Antiga",
            "photos": "Fotos",
            "equipment_identification": "Equipamento",
            "description": "Descrição",
            "procedure_type": "Procedimento",
            "details": "Detalhe",
            "reference_gaf": "Referência GAF",
            "reference_jf": "Referência JF",
            "equipment": "Equipamento Coletivo",
            "equipment_type": "Tipo Equip. Coletivo",
            "exec_init_at": "Data Inicial",
            "exec_end_at": "Data Final",
            "no_workers": "Número de trabalhadores",
            "no_hours": "Número de horas",
            "materials": "Materiais",
            "exec_obs": "Comentário Execução (JF)",
            "image_start": "Imagem Inicial",
            "image_end": "Imagem Final",
            "workers": "Trabalhadores",
            "claimant": "Requerente",
            "unity": "Unidade Orgânica",
            "address": {
                "street": "Morada",
                "place": "Localidade",
                "description": "Endereço",
                "reference_point": "Referência"
            },
            "verification": {
                "image": "Imagem Verificação",
                "obs": "Parecer Verificação (UO)",
                "unity": "Unidade Orgânica Verificadora",
                "abbr_unity": "UO Verificadora",
                "verification_at": "Data Verificação",
                "technical": "Nome Técnico",
            },
            "approbation": {
                "status": "Estado Aprovação",
                "approved": "Aprovado",
                "not_approved": "Não Aprovado",
                "empty": "Não Avaliado",
                "obs": "Parecer Aprovação (GAF)",
            },
            "reception": {
                "payment": {
                    "status": "Estado pagamento",
                    "paid": "Pago",
                    "not_paid": "Não Pago",
                },
                "obs": "Parecer receção",
            },
            "documents": {
                "link": "Ver Ficheiro",
                "file": "Ficheiro",
                "type": "Tipo",
                "code": "Código",
                "description": "Descrição",
            },
        },
        "form": {
            "buttons": {
                "save": "Salvar",
                "delete": "Eliminar",
                "notify": "Notificar",
                "export": "Ficha de Obra",
            },
            "tabs": {
                "general": "Geral",
                "address": "Localização",
                "execution": "Execução",
                "verification": "Verificação/Aprovação",
                "reception": "Receção/Conclusão",
                "approval": "Aprovação",
                "documents": "Documentos",
            },
            "export": {
                "msg_confirm": "Pretende gerar ficha de obra?",
                "msg_generating": "A gerar ficha de obra...",
                "msg_generated": "Ficha de obra",
            },
            "verification": {
                "new": "Nova verificação",
                "title_new": "Nova verificação",
                "title_edit": "Verificação - {date} - {status}"
            },
            "msg": {
                "confirm": {
                    "delete_verification": "Deseja eliminar a verificação?",
                }
            }
        },
        "export": {
            "data": {
                "xls": {
                    "name": "Excel",
                    "title": "Exportar para @:parish_interventions.export.data.xls.name",
                },
                "report": {
                    "name": "Relatório de Execução Física",
                    "title": "Gerar @:parish_interventions.export.data.report.name",
                }
            }
        },
        "add": {
            "title": "Adicionar Obra",
            "tooltip": "Clique no mapa para escolher o local da obra.",
            "error": {
                "outside": "Não é possível registar uma obra fora do concelho.",
                "permission": "Não possui permissão para adicionar uma nova obra",
                "filter": "Necessário ativar os filtros para visualizar a obra.",
                "featureable": "Ocorreu um erro na obtenção da informação para o ponto selecionado",
            },
        }
    },
    "parish_interventions_search": {
        "label": "Filtros",
        "title": "Lista de obras",
        "table": {
            "view": "Consultar Informação",
            "viewOnMap": "Visualizar no mapa",
        },
        "list": {
            "actions": {
                "view-data": {
                    "title": "Consultar Informação",
                    "help": null,
                },
                "view-on-map": {
                    "title": "Visualizar no Mapa",
                    "help": null,
                },
                "apply-on-map": {
                    "title": "Aplicar no Mapa",
                    "help": null,
                },
                "reset-map": {
                    "title": "Limpar Mapa",
                    "help": null,
                },
                "report": {
                    "title": "Relatório de Execução Fisica",
                    "help": null,
                },
            }
        },
        "export": {
            "data": {
                "xls": {
                    "name": "@:parish_interventions.export.data.xls.name",
                    "title": "@:parish_interventions.export.data.xls.title",
                },
                "report": {
                    "name": "@:parish_interventions.export.data.report.name",
                    "title": "@:parish_interventions.export.data.report.title",
                }
            }
        },
        "msg": {
            "export": {
                "confirm": "Pretende {txt}?",
                "processing": "Exportação de <b>{total} elemento</b> em  execução... | Exportação de <b>{total} elementos</b> em  execução...",
                "finished": "Exportação de <b>{total} elemento</b> concluída | Exportação de <b>{total} elementos</b> concluída",
            },
        },
        "report": {
            "description": "Relatório de <b>{num} obra</b> em  execução... | Relatório de <b>{num} obras</b> em  execução...",
            "confirm_message": "Pretende gerar o relatório de execução fisica?",
            "final_description": "Relatório de <b>{num} obra</b> concluída | Relatório de <b>{num} obras</b> concluída",
            "tooltip": "Gerar o relatório de execução fisica",
        }
    },
    "parish_interventions_report": {
        "title": "Relatórios",
        "summary_work": {
            "title": "Listagem de obras",
        },
        "work_counter": {
            "title": "Obras concluidas",
        },
    },
    "parish_interventions_accountable": {
        "title": "Minhas Obras",
        "toggles": {
            "my": {
                "title": "Minhas Obras"
            },
            "unity": {
                "title": "Atribuídas à unidade"
            },
            "verification": {
                "title": "Para verificação"
            }
        },
        "item": {
            "link_map": "ver no mapa",
            "code": "Código",
            "address": "Morada",
            "created_at": "Data de criação",
        },
        "msg": {
            "confirm": {
                "reload": "Deseja efetuar o reload da informação?"
            }
        }
    },
    "parish_interventions_activity": {
        "title": "Atividade Recente",
        "tooltip": "{number} novas obras",
        "no_records": "Sem registos",
        "toggles": {
            "submitted": {
                "title": "Submetidas"
            },
            "completed": {
                "title": "Concluídas"
            }
        },
        "item": {
            "link_map": "ver no mapa",
            "code": "Código",
            "description": "Descrição",
            "address": "Morada",
            "created_at": "Data de criação"
        },
        "msg": {
            "confirm": {
                "reload": "Deseja efetuar o reload da informação?"
            }
        }
    },
    "parish_interventions_overdue": {
        "title": "Alarmística",
        "tooltip": "{number} obras em atraso",
        "load_more_records": "Carregar mais",
        "no_records": "Sem registos",
        "item": {
            "link_map": "ver no mapa",
            "code": "Código",
            "address": "Morada",
            "created_at": "Data de criação",
            "days_overdue": "Dia de atraso | Dias de atraso"
        },
        "msg": {
            "confirm": {
                "reload": "Deseja efetuar o reload da informação?"
            }
        }
    },
    "municipal_interventions": {
        "model": {
            "code": "Código",
            "status": "Estado",
            "parish": "Freguesia",
            "type": "Tipo",
            "created_at": "Data de criação",
            "service_typology": "Tipologia de serviço",
            "updated_at": "Última atualização",
            "description": "Descrição",
            "department": "Departamento",
        },
        "form": {
            "buttons": {
                "report": "Ficha de Obra",
            },
            "report": {
                "msg_confirm": "Pretende gerar ficha de obra?",
                "msg_generating": "A gerar ficha de obra...",
                "msg_generated": "Ficha de obra",
            },
        }
    },
    "municipal_interventions_search": {
        "label": "Filtros",
        "title": "Lista de obras",
        "buttons": {
            "clear": "Limpar pesquisa",
            "search": "Pesquisar",
            "applyOnMap": "Aplicar no mapa",
            "resetMap": "Limpar mapa"
        },
        "table": {
            "title": "Resultados",
            "view": "Consultar Informação",
            "viewOnMap": "Visualizar no mapa",
        },
        "export": {
            "description": "Exportação de <b>{num} elemento</b> em  execução... | Exportação de <b>{num} elementos</b> em  execução...",
            "final_description": "Exportação de <b>{num} elemento</b> concluída | Exportação de <b>{num} elementos</b> concluída"
        },
    },
    "municipal_interventions_report": {
        "title": "Relatórios",
        "global_total": "No total",
        "global_status": {
            "title": "Informações Globais",
        },
        "monthly_summary": {
            "title": "Resumo Mensal",
            "year": "Ano",
            "month": "Mês"
        },
        "work_summary": {
            "title": "Listagem de Obras",
        },
        "status_chart": {
            "title": "Gráfico dos Estados",
        },
        "type_chart": {
            "title": "Gráfico das Tipologias",
        },
    }
}
